const tagTester = ( name: any ) => {
  var tag = '[object ' + name + ']'
  return function(obj: any) {
    return Object.prototype.toString.call(obj) === tag
  }
}

export default tagTester